import React from 'react';
//import Menu from '../../Menu';
import BasePage from './BasePage';
import { connect } from 'react-redux';
import {setMenu} from '../actionCreators';
import Menu from '../components/Menu';
import Table from '../components/Table';
import Modal from '../components/Modal';
import SigningButton from '../components/SigningButton';

class Dashboard extends BasePage {

    loadOnConstructor(){
    	//this.checkConnection();
    	this.parseResponse = this.parseResponse.bind(this);
    	this.getInterface = this.getInterface.bind(this);

    	this.state = {signed_on: false};

	this.getInterface();
    }

    getInterface(){
	const api = this.getApi();
	api.getDashboardInterface(this.parseResponse);
    }

    parseResponse(response){
	if(response.status === 'OK'){
		response.signings = response.signings.map((signing, idx) => {
			signing.signing_type = idx % 2 === 0?"Entrada":"Salida";
			
			const date = new Date(signing.sign_date);
			const dateString =
				("0" + date.getUTCDate()).slice(-2) + "/" +
				("0" + (date.getUTCMonth()+1)).slice(-2) + "/" +
				date.getUTCFullYear() + " " +
				("0" + date.getUTCHours()).slice(-2) + ":" +
				("0" + date.getUTCMinutes()).slice(-2) + ":" +
				("0" + date.getUTCSeconds()).slice(-2);

			signing.formatted_sign_date = dateString;

			return signing;
		});

		this.setState(prevState => {
			return {
				...prevState,
				signings: response.signings,
				signed_on: response.signings.length % 2 !== 0,
				i18n: response.i18n
			}
		});
	}else if(response.auth === false){
		this.navigateTo('/login');
    	}
    }

    render() {
        return (
            <div className="container">
            	<Menu />
                <h3>{this.getTrad('dashboard')}</h3>
                <div className="row mt-4">
                    <div className="col-12">
			<SigningButton config={{
				signed_on: this.state.signed_on,
				callback: this.parseResponse
			}}
			/>
                    </div>
                </div>
                <div className="row mt-4">
			<div className="col-12">
				<Table 
					config = {{
					items: this.state.signings?this.state.signings:[],
					i18n: this.state.i18n?this.state.i18n:[],
						mapping: [
							{original: 'formatted_sign_date', shown: 'Fecha/hora fichaje', visible: true}, 
							{original: 'signing_type', shown: 'Entrada/Salida', visible: true}
						]
					}}
				/>
			</div>
                </div>
                <Modal/>
            </div>
        );
    }
}

const mapStatToProps = state => {
    return {
        menu: state.menu
    };
}

const mapDispatchToProps = dispatch => {
    return {
        setMenu(menu){
            dispatch(setMenu(menu));
        }
    }
}

export default connect(mapStatToProps, mapDispatchToProps)(Dashboard)
